import * as actions from "../../../actions/inn/create";

const initialInnCreate = {
	status: "1",
	clientId: "",
	userId: "",
	errors: {}
};

const initialState = {
	loading: false,
	...initialInnCreate
};

const reducer = function(state = initialState, { type, payload }) {
	switch (type) {
		case actions.SET_VALUE: {
			return {
				...state,
				...payload
			};
		}
		case actions.CLEAR_VALUE: {
			return {
				...state,
				...initialInnCreate
			};
		}
		case actions.ADD_INN: {
			return {
				...state,
				loading: true
			};
		}
		case actions.ADD_INN_FAILED: {
			return {
				...state,
				loading: false
			};
		}
		case actions.ADD_INN_SUCCESS: {
			return {
				...state,
				...initialInnCreate,
				loading: false
			};
		}
		default: {
			return state;
		}
	}
};

export default reducer;
